import { render, staticRenderFns } from "./TypePropertyComponent.vue?vue&type=template&id=584c27c3"
import script from "./TypePropertyComponent.vue?vue&type=script&lang=js"
export * from "./TypePropertyComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports